import React from 'react'
import CookieConsent from 'react-cookie-consent'
import useWindowSize from 'styles/window-size'

import { Wrapper, Content, LinkItem, ButtonClose } from './index.styled'

const CookiesBanner = ({
  buttonText = 'Accept All',
  desktopText = 'We use cookies to improve your experience. By using this website you agree to our',
  desktopLinkText = 'Cookie Policy',
  mobileText = 'This website uses',
  mobileLinkText = 'cookies',
  link = '/legal'
}) => {
  const ref = React.useRef()
  const { width } = useWindowSize()

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      ref?.current?.classList?.add('show')
    }, 6000)
    return () => clearTimeout(timeout)
  }, [])

  const onClose = () => {
    ref?.current?.classList?.remove('show')
  }

  return (
    <Wrapper ref={ref}>
      <CookieConsent
        location='none'
        buttonText={buttonText}
        disableStyles
        containerClasses='cookies-banner'
        buttonClasses='cookies-banner-accept-btn'
        disableButtonStyles
        buttonWrapperClasses='cookies-banner-btns'
        contentClasses='cookies-banner-content'
        expires={150}
      // debug={true}
      >
        <Content>
          {width >= 768
            ? (
              <>
                {desktopText} <LinkItem to={link}>{desktopLinkText}</LinkItem>.
              </>
              )
            : (
              <>
                {mobileText} <LinkItem to={link}>{mobileLinkText}</LinkItem>.
              </>
              )}
        </Content>
        <ButtonClose onClick={onClose} />
      </CookieConsent>
    </Wrapper>
  )
}
export default CookiesBanner
